var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn--arrow btn--blue btn--fill",attrs:{"type":"button"},on:{"click":_vm.nextStep}},[_vm._t("default",[_vm._v("Continue")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }